import { handleVersionMismatch } from 'actions/versionSync';
import { CHOOSE_STORYLET_FAILURE, CHOOSE_STORYLET_REQUESTED, CHOOSE_STORYLET_SUCCESS, } from 'actiontypes/storylet';
import { VersionMismatch } from 'services/BaseService';
import StoryletService from 'services/StoryletService';

import { hideMap } from 'actions/map';
import { processMessages } from 'actions/app';
import { IAppState } from 'types/app';
import { IApiStoryletResponseData } from 'types/storylet/service';

const beginRequest = (eventId: number) => ({
  type: CHOOSE_STORYLET_REQUESTED,
  payload: {
    eventId,
    phase: null,
  },
});

const beginSuccess = (data: IApiStoryletResponseData) => ({
  type: CHOOSE_STORYLET_SUCCESS,
  payload: {
    actions: data.actions,
    phase: data.phase,
    storylets: data.storylets,
    storylet: data.storylet,
    endStorylet: data.endStorylet,
    messages: data.messages,
  },
});

const beginFailure = (error: any) => ({
  type: CHOOSE_STORYLET_FAILURE,
  error: true,
  status: error.response && error.response.status,
});

const service = new StoryletService();

/** ----------------------------------------------------------------------------
 * BEGIN
 -----------------------------------------------------------------------------*/
export default function begin(eventId: number) {
  return async (dispatch: Function, getState: () => IAppState) => {
    // If we are already choosing a storylet, don't send another request
    const { storylet: { isChoosing } } = getState();
    if (isChoosing) {
      return {};
    }

    dispatch(beginRequest(eventId));

    try {
      const { data } = await service.begin(eventId);
      dispatch(beginSuccess(data));


      // Close the map
      dispatch(hideMap());

      // If we have some messages to process (e.g. we have been Must-ed into a new area)
      // process them now.
      if (data.messages) {
        dispatch(processMessages(data.messages));
      }

      return data;
    } catch (error) {
      if (error instanceof VersionMismatch) {
        dispatch(handleVersionMismatch(error));
      }
      dispatch(beginFailure(error));
      return error;
    }
  };
}